import {createSlice} from '@reduxjs/toolkit';

const inspectionReportsModalSlice = createSlice({
  name: 'inspectionReportsModal',
  initialState: {
    vehicle: '',
    equipmentName: '',
    implementName: '',
    isImplementInspection: false,
    selectedVeh: '',
    selectedImplement: '',
    linkedVehicleInspectionReportId: '',
    items: [],
    inspectedDate: '',
    closedDate: '',
    inspectedByUser: '',
    inspectedByOperator: '',
    closedByUser: '',
    comment: '',
    status: null,
    reportDocId: null,
    inspectionNameInput: '',
    vehiclePhotoKeys: [],
    implementPhotoKeys: [],
  },
  reducers: {
    setInspectionReportsModalValues(state, action) {
      const reportData = action.payload;
      state.vehicle = reportData.vehicle || '';
      state.equipmentName = reportData.equipmentName || '';
      state.implementName = reportData.implementName || '';
      state.isImplementInspection = reportData.isImplementInspection || false;
      state.selectedVeh = reportData.selectedVeh || '';
      state.selectedImplement = reportData.selectedImplement || '';
      state.linkedVehicleInspectionReportId = reportData.linkedVehicleInspectionReportId || '';
      state.items = reportData.items;
      state.inspectedDate = reportData.inspectedDate;
      state.closedDate = reportData.closedDate;
      state.inspectedByUser = reportData.inspectedByUser;
      state.inspectedByOperator = reportData.inspectedByOperator || '';
      state.closedByUser = reportData.closedByUser;
      state.comment = reportData.comment;
      state.status = reportData.status;
      state.reportDocId = reportData.reportDocId;
      state.inspectionNameInput = reportData.inspectionNameInput;
      state.vehiclePhotoKeys = reportData.vehiclePhotoKeys || [];
      state.implementPhotoKeys = reportData.implementPhotoKeys || [];
    },
  },
});

export const {setInspectionReportsModalValues} = inspectionReportsModalSlice.actions;
export default inspectionReportsModalSlice.reducer;
